import { Box } from '@mui/material';

interface FlexSectionProps {
  direction?: 'column' | 'row';
  alignItems?: string;
  gap?: number;
  justifyContent?: string;
  sx?: object;
  children: React.ReactNode;
  onClick?: () => void;
}

export const FlexSection = ({
  direction = 'row',
  alignItems,
  justifyContent,
  gap = 8,
  sx,
  children,
  onClick,
}: FlexSectionProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: direction,
        gap: `${gap}px`,
        ...(alignItems && { alignItems }),
        ...(justifyContent && { justifyContent }),
        ...(sx && { ...sx }),
      }}
      {...(onClick && { onClick })}
    >
      {children}
    </Box>
  );
};
